module.exports = __webpack_public_path__ + "static/media/emailBlue.a4ea649c.svg";